var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "notice-wrapper"
  }, [_c("a-list", {
    attrs: {
      "item-layout": "vertical",
      "data-source": _vm.data,
      size: "large"
    },
    scopedSlots: _vm._u([{
      key: "renderItem",
      fn: function (item) {
        return _c("a-list-item", {}, [_c("a-list-item-meta", [_c("p", {
          attrs: {
            slot: "title"
          },
          slot: "title"
        }, [_vm._v(" " + _vm._s(item.user) + " ")]), _c("a-avatar", {
          attrs: {
            slot: "avatar",
            src: item.imgUrl
          },
          slot: "avatar"
        }), _c("div", {
          attrs: {
            slot: "description"
          },
          slot: "description"
        }, [_vm._v(" " + _vm._s(item.description) + " "), _c("div", {
          staticStyle: {
            "margin-top": "8px"
          }
        }, [_vm._v(_vm._s(item.time))])])], 1)], 1);
      }
    }])
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };